import { ref, string } from 'yup';

export const passwordConfirmationSchema = string()
  .required('Please fill out this field')
  .oneOf([ref('password'), null], 'Passwords must match');
